var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionOpeningHour16({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8,15C11.866,15 15,11.866 15,8C15,4.134 11.866,1 8,1C4.134,1 1,4.134 1,8C1,11.866 4.134,15 8,15ZM9,5C9,4.4477 8.5523,4 8,4C7.4477,4 7,4.4477 7,5V8L5.4,9.2C4.9582,9.5314 4.8686,10.1582 5.2,10.6C5.5314,11.0418 6.1582,11.1314 6.6,10.8L8.6,9.3C8.8518,9.1111 9,8.8148 9,8.5V5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionOpeningHour16);
export default __webpack_public_path__ + "static/media/ic_action_opening_hour_16.04c6d3831259f765d838d5ea85824f86.svg";
export { ForwardRef as ReactComponent };